const organizations = {
    require_membership: 'The user must be a member of the organization to proceed.',
    role_names_not_found: 'Invalid role names detected: {{names,list(type:conjunction)}}. Please create these roles first before proceeding.',
};
export default Object.freeze(organizations);
